import React, { useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import i18n from '../../../i18n';
import { Grid } from '@material-ui/core';
import { string } from 'yup';
import ReCAPTCHA from 'react-google-recaptcha'

import { validator } from 'core/form/form';
import { isUIEnabledSelector } from 'state/app/selectors';

import { LargeButton, LargeButtonColor } from 'components/LargeButton/LargeButton';
import { MobilePhoneControlField } from 'components/MobilePhoneControl/MobilePhoneControl';
import { IGNORE_ERROR, PasswordControlField } from 'components/PasswordControl/PasswordControl';
import { PasswordComplexity } from 'pages/Signup/components/PasswordComplexity';

import { Form } from 'forms/types';
import { makeStyles } from '@material-ui/core/styles';
import { UserRole } from 'types';
import { getLocalStorageItem, LocalStorageKey } from 'core/storage/storage';
import { isPossiblePhoneNumber } from 'react-phone-number-input';

const selector = formValueSelector(Form.SIGNUP_FORM);
const recaptchaKey = '6LdwmqcnAAAAACt0mbMAqqBjLRX9T3EmmqhWjTYd';

const useStyles = makeStyles(theme => ({
    signupButton: {
        marginTop: 44,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down(480)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
        },
        [theme.breakpoints.down(360)]: {
            marginTop: theme.spacing(1),
        },
    },
}));

const Captcha = (props: any) => (
    <div>
        <ReCAPTCHA
            sitekey={process.env.RECAPTCHA_SITE_KEY || recaptchaKey}
            onChange={props.input.onChange}
        />
    </div>
);

export const SignupForm = connect(state => ({ password: selector(state, 'password') }))(
    reduxForm({
        form: Form.SIGNUP_FORM,
        initialValues: { username: '', password: '', captcha:'', role: UserRole.VENDOR },
        validate: validator({
            captcha: string().required('common:validation.requiredCaptcha'),
            username: string().test({
                message: 'common:validation.phoneFormat',
                test: value => {
                    if (!value) {
                        return true;
                    }
                    return isPossiblePhoneNumber(value);
                },
            }),
            password: string()
                .required('common:validation.required')
                .matches(/[a-z]|[а-яё]/, IGNORE_ERROR)
                .matches(/[A-Z]|[А-ЯЁ]/, IGNORE_ERROR)
                .matches(/\d/, IGNORE_ERROR)
                .min(8, IGNORE_ERROR),
        }),
    })(props => {
        const { t } = i18n.useTranslation();
        const classes = useStyles();
        // @ts-ignore
        const { handleSubmit, password } = props;
        // const error = useFormSyncError(Form.SIGNUP_FORM);
        const isUIEnabled = useSelector(isUIEnabledSelector);
        const hasFake = getLocalStorageItem(LocalStorageKey.PHONE) === 'fake';

        return (
            <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Field name="username" component={MobilePhoneControlField} label={t('auth:signup.phone')} />
                    </Grid>
                    <Grid item xs={12}>
                        <Field name="password" component={PasswordControlField} label={t('auth:signup.password')} />
                    </Grid>
                    <Grid item xs={12}>
                        <Field name='captcha' component={Captcha}/>
                    </Grid>
                    <Grid item xs={12}>
                        <PasswordComplexity password={password} />
                    </Grid>
                    {/*{error && (*/}
                    {/*    <Grid item xs={12}>*/}
                    {/*        <FormErrorMessage error={error} />*/}
                    {/*    </Grid>*/}
                    {/*)}*/}
                    <Grid className={classes.signupButton} style={{ marginBottom: hasFake && 0 }} item xs={12}>
                        <LargeButton color={LargeButtonColor.SUCCESS} disabled={!isUIEnabled} type="submit">
                            {t('auth:signup.signupButton')}
                        </LargeButton>
                    </Grid>
                </Grid>
            </form>
        );
    }),
);
